import React from 'react';
import Logo2 from '../assets/images/logo2.png';
import BanniHut from '../assets/images/banni-hut.jpg';

const MobileServiceCards = () => {
    const services = [
        {
            id: 1,
            title: 'शिक्षा',
            subtitle: 'Education',
            image: 'Education/kutch-Achary-traning3.jpeg',
            description: 'Empowering communities through quality education',
            color: '#2E5090'
        },
        {
            id: 2,
            title: 'स्वास्थ्य',
            subtitle: 'Health',
            image: 'Health/Medicalcamp-Bhuj2.jpeg',
            description: 'Providing healthcare services to those in need',
            color: '#E8923F'
        },
        {
            id: 3,
            title: 'स्वावलंबन',
            subtitle: 'Skill Enhancement',
            image: 'Sewing_Class_Bani/SwingB3.jpeg',
            description: 'Building skills for a better tomorrow',
            color: '#7AB14B'
        },
        {
            id: 4,
            title: 'सामाजिक',
            subtitle: 'New Homes',
            image: BanniHut,
            description: 'Creating safe spaces for families',
            color: '#C85A8E'
        }
    ];

    return (
        <div className="mobile-services-section d-md-none"
        style={{
                backgroundColor: '#F5E6D3', // Peachy/cream background color
            }}>
            {/* Logo Section */}
            <div className="logo-container text-center py-4">
                <img 
                    src={Logo2} 
                    alt="Seva Sadhana Logo" 
                    className="service-logo"
                    style={{ maxWidth: '80%', height: 'auto' }}
                />
            </div>

            {/* Service Cards Grid */}
            <div className="container px-3 pb-4">
                <div className="row g-3">
                    {services.map((service) => {
                        return (
                            <div key={service.id} className="col-6">
                                <div 
                                    className="service-card h-100"
                                    style={{
                                        backgroundColor: '#fff',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                        cursor: 'pointer',
                                        border: `2px solid ${service.color}`,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                    }}
                                >
                                    {/* Image - Top Half */}
                                    <div 
                                        className="card-image"
                                        style={{
                                            width: '100%',
                                            height: '120px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <img 
                                            src={service.image} 
                                            alt={service.title}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </div>

                                    {/* Content - Bottom Half */}
                                    <div 
                                        className="card-content"
                                        style={{
                                            padding: '15px',
                                            textAlign: 'center',
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <h5 
                                            className="service-title mb-2"
                                            style={{
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                color: '#333',
                                                margin: '0 0 8px 0'
                                            }}
                                        >
                                            {service.title}
                                        </h5>
                                        <p 
                                            className="service-description"
                                            style={{
                                                fontSize: '11px',
                                                color: '#666',
                                                margin: '0',
                                                lineHeight: '1.4'
                                            }}
                                        >
                                            {service.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default MobileServiceCards;